import produce from 'immer';

// TYPES
import { Types, ExcluirStatus } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ExcluirStatus = {
	status: 0,
	data: null,
};

export default function excluirStatusReducer(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirStatus {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_STATUS: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_STATUS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_STATUS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_STATUS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
